<template>
    <!-- Charges mensuelles (remplace l'onglet « Configuration ») : routes v1 config-charges, inchangées -->
    <Transition name="modal-fade" appear>
        <div class="cf-overlay" @click.self="fermer">
            <Transition name="modal-slide" appear>
                <div class="cf-dialog cf-dialog--lg">

                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon" style="color:rgb(var(--primary));background:rgb(var(--primary) / .1);"><i class="ri-settings-4-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">Charges mensuelles</h4>
                                <p class="cf-modal-head__sub">Déduites de la marge pour obtenir le bénéfice net.</p>
                            </div>
                        </div>
                        <button @click="fermer" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <div class="cf-dialog-body">
                        <div v-if="erreur" class="cf-note cf-note--danger" style="margin-bottom:.75rem;"><i class="ri-error-warning-line"></i><span>{{ erreur }}</span></div>

                        <div class="pp-minis">
                            <div class="pp-mk"><span>Fixes</span><b>{{ montant(totalType('fixe')) }}</b></div>
                            <div class="pp-mk"><span>Variables</span><b>{{ montant(totalType('variable')) }}</b></div>
                            <div class="pp-mk"><span>Total actif / mois</span><b class="pp-violet">{{ montant(totalType('fixe') + totalType('variable')) }}</b></div>
                        </div>

                        <div class="pp-wrap">
                            <table class="pp-table">
                                <thead><tr>
                                    <th class="th">Libellé</th><th class="th">Portée</th><th class="th">Type</th>
                                    <th class="th pp-r">Montant / mois</th><th class="th">Active</th><th class="th"></th>
                                </tr></thead>
                                <tbody>
                                    <tr v-if="chargement"><td class="td pp-vide" colspan="6">Chargement…</td></tr>
                                    <tr v-else-if="!charges.length"><td class="td pp-vide" colspan="6">Aucune charge saisie.</td></tr>
                                    <tr v-for="c in charges" :key="c.pid" :class="{ 'pp-inactive': !Number(c.is_active) }">
                                        <td class="td"><b>{{ c.libelle }}</b><small v-if="c.description">{{ c.description }}</small></td>
                                        <td class="td">{{ c.magasin_id ? 'Ce magasin' : 'Toute la société' }}</td>
                                        <td class="td"><span class="pp-badge" :class="c.type_charge === 'fixe' ? 'pp-b-p' : 'pp-b-i'">{{ c.type_charge }}</span></td>
                                        <td class="td pp-r">{{ montant(c.montant_mensuel) }}</td>
                                        <td class="td">
                                            <input type="checkbox" class="cf-check" :checked="!!Number(c.is_active)" :disabled="enregistrement" @change="basculer(c)">
                                        </td>
                                        <td class="td pp-r"><button type="button" class="pp-iconbtn" title="Modifier" @click="editer(c)"><i class="ri-pencil-line"></i></button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="pp-form">
                            <div class="pp-form__titre">{{ form.pid ? 'Modifier la charge' : 'Ajouter une charge' }}
                                <small>{{ magasin ? '(rattachée au magasin sélectionné)' : '(pour toute la société)' }}</small></div>
                            <div class="pp-form__ligne">
                                <div>
                                    <label class="cf-field-label">Libellé</label>
                                    <input v-model="form.libelle" class="pp-inp" maxlength="255" placeholder="ex : Électricité" :readonly="!!form.pid"
                                           :title="form.pid ? 'Le libellé d\'une charge existante ne se modifie pas : désactivez-la et créez-en une autre.' : ''">
                                </div>
                                <div>
                                    <label class="cf-field-label">Type</label>
                                    <select v-model="form.type_charge" class="pp-inp"><option value="fixe">Fixe</option><option value="variable">Variable</option></select>
                                </div>
                                <div>
                                    <label class="cf-field-label">Montant / mois</label>
                                    <input v-model.number="form.montant_mensuel" type="number" min="0" class="pp-inp" placeholder="0">
                                </div>
                                <div class="pp-form__btns">
                                    <button v-if="form.pid" type="button" class="ds-btn-ghost" @click="nouveau">Annuler</button>
                                    <button type="button" class="ti-btn ti-btn-primary-full" :disabled="enregistrement" @click="enregistrer">
                                        <i :class="form.pid ? 'ri-save-line' : 'ri-add-line'"></i>{{ form.pid ? 'Enregistrer' : 'Ajouter' }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="cf-dialog-foot">
                        <button @click="fermer" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                    </div>
                </div>
            </Transition>
        </div>
    </Transition>
</template>

<script>
import { appelPP, montant } from "./appelpp";

const VIDE = () => ({ pid: "", type_charge: "fixe", libelle: "", description: "", montant_mensuel: null, is_active: true, magasin_id: "" });

export default {
    name: "ModalCharges",
    emits: ["fermer", "modifie"],
    props: { magasin: { type: String, default: "" } },
    data() {
        return { charges: [], chargement: false, enregistrement: false, erreur: "", form: VIDE(), modifie: false };
    },
    mounted() { this.charger(); },
    methods: {
        montant,
        totalType(t) {
            return this.charges.filter((c) => c.type_charge === t && Number(c.is_active)).reduce((s, c) => s + (parseFloat(c.montant_mensuel) || 0), 0);
        },
        async charger() {
            this.chargement = true;
            try {
                const r = await appelPP(this.$store, "config-charges", { magpid: this.magasin || "" });
                this.charges = r ? (r.datas || []) : [];
                if (!r) this.erreur = "Impossible de charger les charges.";
            } catch (e) {
                console.error(e);
                this.erreur = "Impossible de charger les charges.";
            } finally {
                this.chargement = false;
            }
        },
        nouveau() { this.form = VIDE(); },
        editer(c) {
            this.form = {
                pid: c.pid, type_charge: c.type_charge, libelle: c.libelle, description: c.description || "",
                montant_mensuel: parseFloat(c.montant_mensuel) || 0, is_active: !!Number(c.is_active), magasin_id: c.magasin_id || ""
            };
        },
        basculer(c) {
            this.editer(c);
            this.form.is_active = !this.form.is_active;
            this.enregistrer();
        },
        async enregistrer() {
            this.erreur = "";
            if (!this.form.libelle || !this.form.libelle.trim()) { this.erreur = "Le libellé est requis."; return; }
            if (this.form.montant_mensuel === null || isNaN(this.form.montant_mensuel) || this.form.montant_mensuel < 0) {
                this.erreur = "Le montant mensuel est invalide."; return;
            }
            this.enregistrement = true;
            try {
                const r = await appelPP(this.$store, "config-charges/save", {
                    pid: this.form.pid,
                    // une charge existante garde sa portée ; une nouvelle suit le magasin sélectionné
                    magasin_id: this.form.pid ? this.form.magasin_id : (this.magasin || ""),
                    type_charge: this.form.type_charge,
                    libelle: this.form.libelle.trim(),
                    description: this.form.description,
                    montant_mensuel: this.form.montant_mensuel,
                    is_active: this.form.is_active
                });
                if (!r) { this.erreur = "Échec de l'enregistrement."; return; }
                this.modifie = true;
                this.form = VIDE();
                await this.charger();
            } catch (e) {
                console.error(e);
                this.erreur = "Erreur serveur lors de l'enregistrement.";
            } finally {
                this.enregistrement = false;
            }
        },
        // En fermant après une modification, la page relit les prévisions sans cache (bénéfice net à jour).
        fermer() {
            if (this.modifie) this.$emit("modifie");
            this.$emit("fermer");
        }
    }
};
</script>

<style scoped>
.cf-overlay { position: fixed; inset: 0; z-index: 1000; display: flex; align-items: flex-start; justify-content: center; padding: 4vh 1rem; background: rgb(15 23 42 / 0.45); }
.cf-dialog { width: 100%; background: #fff; border-radius: var(--cf-radius, .625rem); box-shadow: var(--cf-shadow-md); display: flex; flex-direction: column; max-height: 92vh; overflow: hidden; }
.cf-dialog--lg { max-width: 820px; }
.cf-dialog-head { display: flex; align-items: center; justify-content: space-between; padding: 1rem 1.25rem; border-bottom: 1px solid var(--cf-border, #e2e8f0); flex-shrink: 0; }
.cf-dialog-title { margin: 0; font-size: .95rem; font-weight: 700; color: var(--cf-ink-strong, #0f172a); }
.cf-dialog-close { height: 2rem; width: 2rem; flex-shrink: 0; display: inline-flex; align-items: center; justify-content: center; border-radius: .5rem; border: none; background: #f1f5f9; color: #64748b; cursor: pointer; }
.cf-dialog-close:hover { background: #fee2e2; color: rgb(var(--danger)); }
.cf-dialog-body { padding: 1.1rem 1.25rem; overflow-y: auto; }
.cf-dialog-foot { display: flex; align-items: center; justify-content: flex-end; gap: .6rem; padding: .9rem 1.25rem; border-top: 1px solid var(--cf-border, #e2e8f0); background: #f8fafc; flex-shrink: 0; }
.modal-fade-enter-active, .modal-fade-leave-active { transition: opacity .25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity: 0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition: all .25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity: 0; transform: translateY(-16px); }

.pp-violet { color: rgb(var(--primary)) !important; }
.pp-minis { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: .6rem; margin-bottom: 1rem; }
.pp-mk { padding: .7rem .8rem; border-radius: .5rem; background: #f8fafc; border: 1px solid #e2e8f0; }
.pp-mk span { font-size: .7rem; color: #64748b; font-weight: 600; text-transform: uppercase; letter-spacing: .03em; display: block; }
.pp-mk b { display: block; font-size: 1.05rem; font-variant-numeric: tabular-nums; color: #0f172a; }
.pp-wrap { overflow-x: auto; }
.pp-table { width: 100%; border-collapse: collapse; font-size: 13px; min-width: 560px; }
.th { padding: .6rem .8rem; font-weight: 600; font-size: .72rem; color: #1e293b; background: #f1f5f9; border-bottom: 1px solid #e2e8f0; white-space: nowrap; text-align: left; }
.td { padding: .55rem .8rem; border-bottom: 1px solid #e2e8f0; white-space: nowrap; color: #1e293b; font-variant-numeric: tabular-nums; }
.td small { display: block; color: #94a3b8; font-size: .7rem; }
.pp-r { text-align: right !important; }
.pp-vide { text-align: center; color: #94a3b8; }
.pp-inactive .td { color: #94a3b8; }
.pp-badge { display: inline-flex; font-size: .68rem; font-weight: 700; padding: .15rem .5rem; border-radius: 99px; }
.pp-b-p { background: rgb(var(--primary) / .1); color: rgb(var(--primary)); }
.pp-b-i { background: rgb(var(--info) / .12); color: #2a8dc6; }
.pp-iconbtn { width: 30px; height: 30px; border-radius: .375rem; border: 1px solid #e2e8f0; background: #fff; color: #64748b; cursor: pointer; display: inline-grid; place-items: center; }
.pp-iconbtn:hover { color: rgb(var(--primary)); border-color: rgb(var(--primary) / .4); }
.pp-form { margin-top: 1rem; padding: .9rem; border: 1px dashed #e2e8f0; border-radius: .625rem; background: #fcfcfe; }
.pp-form__titre { font-weight: 700; font-size: .84rem; color: #0f172a; margin-bottom: .6rem; }
.pp-form__titre small { font-weight: 500; color: #94a3b8; }
.pp-form__ligne { display: grid; grid-template-columns: 2fr 1fr 1fr auto; gap: .6rem; align-items: end; }
.pp-form__btns { display: flex; gap: .4rem; }
.pp-inp { width: 100%; height: 38px; border: 1px solid rgb(var(--input-border, 203 213 225)); border-radius: .5rem; padding: 0 .7rem; font-size: .82rem; outline: none; background: #fff; }
.pp-inp:focus { border-color: rgb(var(--primary)); box-shadow: 0 0 0 3px rgb(var(--primary) / .10); }
.pp-inp[readonly] { background: #f8fafc; color: #64748b; }
@media (max-width: 640px) {
    .pp-minis { grid-template-columns: 1fr; }
    .pp-form__ligne { grid-template-columns: 1fr 1fr; }
    .pp-form__btns { grid-column: 1 / -1; justify-content: flex-end; }
}
</style>
